import type { BulkViewData } from '../../hooks/useBulkViewData/types'
import { useSelector } from 'react-redux'
import { List, ListItem, Stack, Typography } from '@mui/material'
import { selectLoadsFromVehiclesAsSet } from '@/features/domain/vehicle'
import { preview } from '@/components/form/preview'
import { useCreateFormatNumber } from '@/hooks'
import { useTexts } from './hooks/useTexts'
import { LoadName } from '../../../components/LoadName'
import { LoadsAlert } from '../../../components/LoadsAlert'

type Props = {
  bulkData: BulkViewData
}

export function Loads(props: Props) {
  const {
    bulkData: { loads },
  } = props

  const texts = useTexts()
  const formatNumber = useCreateFormatNumber()
  const vehiclesLoads = useSelector(selectLoadsFromVehiclesAsSet)

  const hasAtLeastOneWarning = Object.keys(loads.value).some(l => !vehiclesLoads.has(l))
  const hasExactLoads = Object.keys(loads.value).length > 0

  if (!hasExactLoads && !loads.hasAlsoMixedValues) {
    return (
      <preview.Field label={texts.loads.label}>
        <preview.NullValue />
      </preview.Field>
    )
  }

  return (
    <preview.Field label={texts.loads.label}>
      <Stack gap={1} component="span">
        <List dense disablePadding component="span">
          {Object.entries(loads.value).map(([key, value]) => (
            <preview.LabelValueRow
              key={`${key}-${value}`}
              label={<LoadName name={key} vehiclesLoads={vehiclesLoads} />}
            >
              {formatNumber((value as number) / 100)}
            </preview.LabelValueRow>
          ))}
          {loads.hasAlsoMixedValues && (
            <ListItem disablePadding>
              <Typography variant="body2">
                {hasExactLoads ? texts.loads.plusMixed : texts.loads.mixed}
              </Typography>
            </ListItem>
          )}
        </List>
        {hasAtLeastOneWarning && <LoadsAlert />}
      </Stack>
    </preview.Field>
  )
}
